(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["zwei-spalten"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {

  // Rabattcode-Popup mit konfigurierbarer Verzögerung
  var promoPopup = document.getElementById('promoPopup');
  if (promoPopup) {
    var closeBtn = promoPopup.querySelector('.cv-promo-close');
    var copyBtn = promoPopup.querySelector('.cv-promo-copy-btn');
    var copyLabel = promoPopup.querySelector('.cv-promo-copy-label');
    var code = promoPopup.getAttribute('data-code') || '';
    var delay = parseInt(promoPopup.getAttribute('data-delay') || '2', 10) * 1000;
    var originalLabel = copyLabel ? copyLabel.textContent : '';
    var storageKey = 'promoPopupShown_v1';

    var showPopup = function () {
      if (!localStorage.getItem(storageKey)) {
        setTimeout(function () {
          promoPopup.classList.add('is-visible');
          localStorage.setItem(storageKey, 'true');
        }, delay);
      }
    };

    var hidePopup = function () {
      promoPopup.classList.remove('is-visible');
    };

    var showCopiedAndClose = function () {
      copyBtn.classList.add('is-copied');
      if (copyLabel) { copyLabel.textContent = 'Kopiert!'; }
      setTimeout(function () {
        hidePopup();
        setTimeout(function () {
          copyBtn.classList.remove('is-copied');
          if (copyLabel) { copyLabel.textContent = originalLabel; }
        }, 300);
      }, 800);
    };

    var fallbackCopy = function (text) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.left = '-999999px';
      document.body.appendChild(ta);
      ta.focus();
      ta.select();
      try { document.execCommand('copy'); showCopiedAndClose(); } catch (e) {}
      document.body.removeChild(ta);
    };

    if (closeBtn) { closeBtn.addEventListener('click', hidePopup); }
    promoPopup.addEventListener('click', function (e) {
      if (e.target === promoPopup) { hidePopup(); }
    });

    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(showCopiedAndClose).catch(function () { fallbackCopy(code); });
        } else {
          fallbackCopy(code);
        }
      });
    }

    showPopup();
  }

  // Kategorie-Slider
  document.querySelectorAll('.cv-cs').forEach(function (slider) {
    var track = slider.querySelector('.cv-cs__track');
    var prev = slider.querySelector('.cv-cs__arrow--prev');
    var next = slider.querySelector('.cv-cs__arrow--next');
    if (!track || !prev || !next) { return; }

    var scrollStep = function () {
      var card = track.querySelector('.cv-cs__card');
      var cardWidth = card ? card.offsetWidth + 12 : 200;
      return Math.max(cardWidth, track.clientWidth * 0.8);
    };

    var updateArrows = function () {
      var maxScroll = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maxScroll;
    };

    prev.addEventListener('click', function () { track.scrollBy({ left: -scrollStep(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: scrollStep(), behavior: 'smooth' }); });
    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();
  });
});

  } catch(e) { console.error(e); }
})();
})();
